import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { randomizer } from 'Utils';
import { CourseCardSkeleton } from 'Shared/CourseCardV3/skeletons';
import { formatProduct } from 'Jsx/Utils/buyProduct';
import SearchCard from './SearchCards';
import GroupList from '../GroupList';
import { CourseCardWrapper } from '../../ui/CourseCardWrapper';
import { Mobile, DesktopStyled } from './styles';

const CourseSkeletonWrapperDesktop = CourseCardWrapper.withComponent(
  CourseCardSkeleton,
);

const CourseSkeletonWrapperMobile = CourseCardWrapper.withComponent(
  CourseCardSkeleton,
);

// eslint-disable-next-line
class CourseList extends Component {
  render() {
    const {
      loading,
      title,
      courses,
      seeAllText,
      fullWidthButton,
      helpText,
      skeletonItems,
      onSeeMore,
      addCourseToCart,
      removeCourseFromCart,
      isUserLogged,
      isMobile,
      user,
      itemsPerRow,
      isOrganization,
      userLanguage,
    } = this.props;

    return (
      <GroupList
        title={title}
        seeAllText={seeAllText}
        fullWidthButton={fullWidthButton}
        helpText={helpText}
        onSeeMore={onSeeMore}
      >
        {loading ? (
          <React.Fragment>
            <DesktopStyled>
              {Array.from(Array(skeletonItems)).map(() => (
                <CourseSkeletonWrapperDesktop
                  itemsPerRow={itemsPerRow}
                  key={randomizer.getString()}
                />
              ))}
            </DesktopStyled>
            <Mobile>
              {Array.from(Array(skeletonItems)).map(() => (
                <CourseSkeletonWrapperMobile
                  itemsPerRow={itemsPerRow}
                  key={randomizer.getString()}
                />
              ))}
            </Mobile>
          </React.Fragment>
        ) : (
          courses.map((c, i) => (
            <CourseCardWrapper
              itemsPerRow={itemsPerRow}
              key={c.originalId}
              isMobile={isMobile}
            >
              <SearchCard
                index={i}
                {...c}
                product={formatProduct(c, 'course')}
                userLanguage={userLanguage}
                addCourseToCart={addCourseToCart}
                removeCourseFromCart={removeCourseFromCart}
                user={user}
                isUserLogged={!!isUserLogged}
                isOrganization={isOrganization}
                onImageHover
                showProfessorPicture={window.innerWidth > 767}
              />
            </CourseCardWrapper>
          ))
        )}
      </GroupList>
    );
  }
}

CourseList.propTypes = {
  user: PropTypes.shape({}),
  loading: PropTypes.bool,
  title: PropTypes.string,
  courses: PropTypes.arrayOf(
    PropTypes.shape({
      affiliateCommission: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
      affiliateUrl: PropTypes.string,
      buyUrl: PropTypes.string,
      discount: PropTypes.number,
      duration: PropTypes.number,
      id: PropTypes.number,
      imagePlaceholder: PropTypes.string,
      inShoppingCart: PropTypes.bool,
      isEnrolled: PropTypes.bool,
      isEnrollment: PropTypes.bool,
      level: PropTypes.shape({
        name: PropTypes.string,
      }),
      originalId: PropTypes.number,
      prices: PropTypes.shape({
        currencySymbol: PropTypes.string,
        price: PropTypes.number,
        realPrice: PropTypes.number,
      }),
      promoImage: PropTypes.string,
      score: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.number]),
      title: PropTypes.string,
      url: PropTypes.string,
      professor: PropTypes.shape({
        fullName: PropTypes.string,
      }),
    }),
  ),
  seeAllText: PropTypes.string,
  fullWidthButton: PropTypes.bool,
  helpText: PropTypes.string,
  skeletonItems: PropTypes.number,
  onSeeMore: PropTypes.func,
  removeCourseFromCart: PropTypes.func.isRequired,
  addCourseToCart: PropTypes.func.isRequired,
  isUserLogged: PropTypes.bool,
  isMobile: PropTypes.bool,
  itemsPerRow: PropTypes.shape({
    1680: PropTypes.number,
    1440: PropTypes.number,
    1280: PropTypes.number,
    1024: PropTypes.number,
    768: PropTypes.number,
  }),
  isOrganization: PropTypes.bool,
  userLanguage: PropTypes.string.isRequired,
};

CourseList.defaultProps = {
  loading: false,
  title: null,
  courses: undefined,
  seeAllText: null,
  fullWidthButton: false,
  helpText: null,
  skeletonItems: 0,
  onSeeMore: undefined,
  userId: null,
  isUserLogged: false,
  isMobile: false,
  user: null,
  itemsPerRow: {
    1680: 4,
    1440: 3,
    1280: 3,
    1024: 3,
    768: 3,
  },
  isOrganization: false,
};

export default CourseList;
